module.exports = __webpack_public_path__ + "static/media/rect.50da356f.png";